import React from 'react'


const Settings : React.FC = () => {
  console.log('ok')
  return (
    <>
    </>
  )
}

export default Settings
